import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as sdkTypes from '@vansite/ts-sharetribe-flex-sdk/types';
import Decimal from 'decimal.js';
import React from 'react';
import { useIntl } from 'react-intl';

import config from '../../../config';
import { formatMoney } from '../../../util/currency';
import { FormattedMessage } from '../../../util/reactIntl';
import { LINE_ITEM_CUSTOMER_COMMISSION, LINE_ITEM_CUSTOMER_COMMISSION_EXTRA_LINE_ITEMS, } from '../../../util/types';
import { itemValueStyles, lineItemStyles } from './BookingBreakdown.styles';

const { Money } = sdkTypes;

/**
 * Renders the commission the customer is charged — the nightly one plus the one
 * on the extra line items.
 *
 * A stay the annual pass covers has its nightly commission zeroed by
 * adjustLineItemsForDisplay, so only the commission on the extras is left.
 *
 * @param {Object} props
 * @param {Array} props.lineItems line items to display, see adjustLineItemsForDisplay
 * @param {boolean} props.isCustomer whether the breakdown is rendered for the customer
 */
const LineItemCustomerCommissionMaybe = ({ lineItems, isCustomer }) => {
  const intl = useIntl();

  if (!isCustomer) return null;

  const customerCommissionLineItem = lineItems.find(
    (item) =>
      item.code === LINE_ITEM_CUSTOMER_COMMISSION && !item.reversal && item.lineTotal.amount > 0,
  );

  const customerCommissionExtraLineItem = lineItems.find(
    (item) =>
      item.code === LINE_ITEM_CUSTOMER_COMMISSION_EXTRA_LINE_ITEMS &&
      !item.reversal &&
      item.lineTotal.amount > 0,
  );

  const commissionAmount =
    (customerCommissionLineItem?.lineTotal.amount || 0) +
    (customerCommissionExtraLineItem?.lineTotal.amount || 0);

  const formattedCommission = formatMoney(
    intl,
    new Money(
      new Decimal(commissionAmount).round().toNumber(),
      customerCommissionLineItem?.lineTotal.currency ||
      customerCommissionExtraLineItem?.lineTotal.currency ||
      config.currency,
    ),
  );

  return (
    <Box sx={lineItemStyles}>
      <Typography sx={{ flex: 1 }} variant="lineItemLabel">
        <FormattedMessage id="BookingBreakdown.commission" />
      </Typography>
      <Typography sx={itemValueStyles} variant="lineItemLabel">{formattedCommission}</Typography>
    </Box>
  );
};

export default LineItemCustomerCommissionMaybe;
